"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEARCHABLE DROPDOWN : DROPDOWN ITEM : STYLES --------------- ++++++++++ */


var _default = {
  dropDownItem: {
    display: 'flex',
    alignItems: 'center',
    padding: (0, _index.replacePXinStringWithEM)('7px 0'),
    fontSize: (0, _index.pxToEm)(14),
    fontWeight: '500',
    color: _index.theme.color.supporting.medium.swatch,
    background: _index.theme.color.light.light.swatch,
    cursor: 'pointer',
    transition: 'all .15s',
    '& .itemtext': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    '&:hover': {
      color: _index.theme.color.primary.medium.swatch
    },
    '& .highlight': {
      fontWeight: '600',
      background: _index.theme.color.primary.light.swatch
    }
  }
};
exports.default = _default;